import { DocketViewDto, TodoDto } from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpoint-definition';

export const todoRequests = {
  getTodos: EndpointDefinition.get<
    DocketViewDto,
    { guideId: string; includeMemberDetails?: boolean }
  >({
    name: 'getTodosByGuide',
    route: '/users/:guideId/todos',
  }),

  snoozeTodo: EndpointDefinition.post<
    TodoDto,
    null,
    { guideId: string; todoId: number }
  >({
    name: 'createTodoSnooze',
    route: '/users/:guideId/todos/:todoId/snooze',
  }),
};
